//pages/not-found.tsx
import { Card, CardContent } from "@/components/ui/card";
// SEO: Import SEO component; mark 404 page as noindex to prevent indexing of error content.
import SEO from '@/components/SEO';
import { AlertCircle } from "lucide-react";
import Layout from "@/components/Layout";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

export default function NotFound() {
  const online = useOnlineStatus();

  if (!online) {
    // Use the app-wide offline gating in Layout for consistency.
    return (
      <Layout>
        <div />
      </Layout>
    );
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50">
      {/* SEO TAGS: 404 page set to noindex to avoid thin/duplicate content in SERPs. */}
      <SEO
        title="404 Not Found | TradeSagePro"
        description="The page you requested was not found on TradeSagePro."
        canonical="https://tradesagepro.com/404"
        noindex
        type="website"
      />
      {/* END SEO TAGS */}
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-gray-900">404 Page Not Found</h1>
          </div>

          <p className="mt-4 text-sm text-gray-600">
            Did you forget to add the page to the router?
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
